import { MenuInterface } from '../../../entities';

export const HeaderMenus: { globalMenu: MenuInterface[]; primary: MenuInterface[]; secondary: MenuInterface[] } = {
  globalMenu: [],
  primary: [
    {
      href: 'https://jp.benzinga.com/news/japan/',
      label: '日本のニュース',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          { href: 'https://jp.benzinga.com/news/japan/stocks/', label: '株式', title: '株式' },
          { href: 'https://jp.benzinga.com/news/japan/indices/', label: '指数', title: '指数' },
          { href: 'https://jp.benzinga.com/news/japan/bonds/', label: '債券', title: '債券' },
          { href: 'https://jp.benzinga.com/news/japan/etfs/', label: 'ETFs', title: 'ETFs' },
          { href: 'https://jp.benzinga.com/news/japan/economy/', label: '経済', title: '経済' },
          { href: 'https://jp.benzinga.com/news/japan/general/', label: '一般', title: '一般' },
        ],
      },
      title: '日本のニュース',
      width: '57px',
    },
    {
      href: 'https://jp.benzinga.com/news/usa/',
      label: '米国',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://jp.benzinga.com/news/usa/stocks/',
            label: '株式',
            title: '株式',
          },
          {
            href: 'https://jp.benzinga.com/news/usa/indices/',
            label: '指数',
            title: '指数',
          },
          {
            href: 'https://jp.benzinga.com/news/usa/earnings/',
            label: '業績発表',
            title: '業績発表',
          },
          {
            href: 'https://jp.benzinga.com/news/usa/economy/',
            label: '経済',
            title: '経済',
          },
          {
            href: 'https://jp.benzinga.com/news/usa/other-markets/',
            label: '他の市場',
            title: '他の市場',
          },
          {
            href: 'https://jp.benzinga.com/news/usa/analystratings/',
            label: 'アナリストレーティング',
            title: 'アナリストレーティング',
          },
          {
            href: 'https://jp.benzinga.com/news/usa/trading/',
            label: '取引',
            title: '取引',
          },
          {
            href: 'https://jp.benzinga.com/news/usa/pressreleases/',
            label: 'プレスリリース',
            title: 'プレスリリース',
          },
        ],
      },
      width: '75px',
    },
    {
      href: 'https://jp.benzinga.com/news/global/',
      label: 'グローバル',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://jp.benzinga.com/news/global/europe/',
            label: 'ヨーロッパ',
            title: 'ヨーロッパ',
          },
          {
            href: 'https://jp.benzinga.com/news/global/asia/',
            label: 'アジア',
            title: 'アジア',
          },
        ],
      },
      title: 'グローバル',
      width: '57px',
    },
    {
      href: 'https://jp.benzinga.com/crypto/',
      label: '仮想通貨',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://jp.benzinga.com/crypto/news/',
            label: 'ニュース',
            title: 'ニュース',
          },
          {
            href: 'https://jp.benzinga.com/crypto/altcoins/',
            label: 'アルトコイン',
            title: 'アルトコイン',
          },
          {
            href: 'https://jp.benzinga.com/crypto/bitcoin/',
            label: 'ビットコイン',
            title: 'ビットコイン',
          },
          {
            href: 'https://jp.benzinga.com/crypto/blockchain/',
            label: 'ブロックチェーン',
            title: 'ブロックチェーン',
          },
          {
            href: 'https://jp.benzinga.com/category/crypto/dogecoin/',
            label: 'ドージコイン',
            title: 'ドージコイン',
          },
          {
            href: 'https://jp.benzinga.com/category/crypto/ethereum/',
            label: 'イーサリアム',
            title: 'イーサリアム',
          },
          {
            href: 'https://jp.benzinga.com/category/crypto/shiba-inu/',
            label: 'シバイヌ',
            title: 'シバイヌ',
          },
          {
            href: 'https://jp.benzinga.com/crypto/nfts/',
            label: 'NFTs',
            title: 'NFTs',
          },
        ],
      },
      title: '仮想通貨',
      width: '57px',
    },
    {
      href: 'https://jp.benzinga.com/education/',
      label: '教育',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://jp.benzinga.com/education/how-to-invest-in-crypto/',
            label: '仮想通貨',
            title: '仮想通貨',
          },
          {
            href: 'https://jp.benzinga.com/education/forex/',
            label: '外国為替',
            title: '外国為替',
          },
          {
            href: 'https://jp.benzinga.com/education/how-to-invest-in-stocks/',
            label: '株式投資',
            title: '株式投資',
          },
        ],
      },
      title: '教育',
      width: '57px',
    },
  ],
  secondary: [],
};
